export default __webpack_public_path__ + "static/media/cambodia.e780e37a.jpg";